import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {isEmpty} from '@grapecity/wijmo';
import {getFormSyncWarnings, getFormValues, reduxForm} from 'redux-form';
import {DataMap} from '@grapecity/wijmo.grid';
import {AutoComplete} from '@grapecity/wijmo.input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Typography from '@mui/material/Typography';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Divider from '@mui/material/Divider';
import {HttpStatusCode} from 'axios';
import {getSessionObject} from '../../../../common/Session.js';
import {GMN, GMN_PATH, CATEGORY_TYPE, OPERATION_PERMISSION_TYPE,
  SURVEY_YEAR_CONSIGNAREA_STATUS, NW_OFFICE_CODE, CORP_CD, STEP_APPROVAL_STATUS} from '../../../../common/commonConst.js';
import {createFieldItems, createGridFields, sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import {postRequest} from '../../../../common/backend.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import DangerButton from '../../../atoms/Buttons/DangerButton.js';
import SCI1003 from '../../SCI/SCI1003';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import {requiredCheck, dateCheck, filterErrorMessage,
  errorResult, lengthCheck, yearIntegerCheck} from '../../../../common/inputCheck.js';
import {getNewNwOfficeMap, searchMap, formatStringDate,
  ISO_LOCAL_DATE_TIME, formatDate, createMessageLabel,
  getOldNwOfficeMap, formatRowIndex, getComboName, setComboList} from '../../../../common/common.js';


// 申請情報Items
const gmnItemsOrder = {
  OrderNo: {binding: 'orderNo', label: '申請番号', required: false, type: 'text', sm: 2, readOnly: true},
  SurveyCompanyCode: {binding: 'surveyCompanyCode', label: '', required: true, type: 'select', sm: 2, readOnly: false},
  NwOfficeCode: {binding: 'nwOfficeCode', label: 'NW事業所', required: true, type: 'select', sm: 2, readOnly: false},
  IssuerUserName: {binding: 'issuerUserName', label: '作成者', required: false, type: 'text', sm: 2, readOnly: true},
  CreateDate: {binding: 'createDate', label: '作成日', required: true, type: 'date', sm: 2, variant: 'outlined', readOnly: false, blank: true},
  ApprovalStatus: {binding: 'approvalStatus', label: '', required: false, type: 'text', sm: 1, readOnly: true},
  ApprovalStatusName: {binding: 'approvalStatusName', label: 'ステータス', required: false, type: 'text', sm: 1, readOnly: true},
  SurveyCheckInputformId: {binding: 'surveyCheckInputformId', label: '', required: false, type: 'text', sm: 1, readOnly: true},
  UpdateTime: {binding: 'updateTime', label: '', required: false, type: 'date', sm: 1, readOnly: true},
  OrderFiscalYear: {binding: 'orderFiscalYear', label: '', required: false, type: 'text', sm: 1, readOnly: true},
  BasisYear: {binding: 'basisYear', label: '', required: false, type: 'text', sm: 1, readOnly: true},
};

// 承認ステータスItems
const gmnItemsStepApproval = {
  StepApprovalComment: {binding: 'stepApprovalComment', label: '否決コメント', required: false, type: 'text', sm: 6, variant: 'outlined', multiline: true, rows: 3, readOnly: true},
  StepApprovalDateTime: {binding: 'stepApprovalDateTime', label: '否決日', required: false, type: 'text', sm: 2, readOnly: true},
  StepApprovalStatus: {binding: 'stepApprovalStatus', label: '', required: false, type: 'text', sm: 2, readOnly: true},
  Approvable: {binding: 'approvable', label: '', required: false, type: 'text', sm: 2, readOnly: true},
  WfId: {binding: 'wfId', label: '', required: false, type: 'text', sm: 2, readOnly: true},
  ApprovalRouteId: {binding: 'approvalRouteId', label: '', required: false, type: 'text', sm: 2, readOnly: true},
  ApprovalStepId: {binding: 'approvalStepId', label: '', required: false, type: 'text', sm: 2, readOnly: true},
};


// 調査年度・委託エリア登録一覧
const gridItems = [
  {binding: 'oldNwOfficeCode', header: '旧NW事業所', dataType: 'Select', width: 100, readOnly: true, visible: true},
  {binding: 'blockNo', header: '区画番号', dataType: 'String', width: 100, readOnly: true, visible: true},
  {binding: 'lastSurveyFiscalYear', header: '前回調査年度', dataType: 'String', width: 125, readOnly: true, visible: true},
  {header: '次回調査年度', dataType: 'header', elems: [
    {binding: 'nextSurveyFiscalYearBefore', header: '変更前', dataType: 'String', width: 80, readOnly: true, visible: true},
    {binding: 'nextSurveyFiscalYearAfter', header: '変更後', dataType: 'String', required: true, width: 80, readOnly: false, visible: true, maxLength: 4},
  ]},
  {binding: 'lastSurveyCheckConsignAreaCode', header: '前回委託エリア', dataType: 'Select', width: 140, readOnly: true, visible: true},
  {header: '次回委託エリア', dataType: 'header', elems: [
    {binding: 'nextSurveyCheckConsignAreaCodeBefore', header: '変更前', dataType: 'Select', width: 80, readOnly: true, visible: true},
    {binding: 'nextSurveyCheckConsignAreaCodeAfter', header: '変更後', required: true, dataType: 'Select', width: 100, readOnly: false, visible: true},
  ]},
  {binding: 'remark', header: '備考', dataType: 'String', width: 300, readOnly: false, visible: true, maxLength: 50},
  {binding: 'blockTransferDetailId', header: '区画異動明細ID', dataType: 'Number', visible: false, readOnly: true},
  {binding: 'transferDetailUpdateTime', header: '区画異動明細更新日時', dataType: 'String', visible: false, readOnly: true},
  {binding: 'blockUpdateTime', header: '区画番号更新日時', dataType: 'String', visible: false, readOnly: true},
  {binding: 'orderVersion', header: '申請バージョン', dataType: 'String', visible: false, readOnly: true},
  {binding: 'gridStatus', header: '', dataType: 'String', visible: false, readOnly: true},
];

/**
 * 調査年度・委託エリア登録
 * 画面ID:SCI1002
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    const storage = getSessionObject(GMN.SURVEY_YEAR_COMPANY_INFO.id);
    let list = [].concat(
          storage?.transitionList != null ? storage.transitionList : []);
    list.push({gmnName: GMN.SURVEY_YEAR_COMPANY_INFO.name, href: ''});

    this.isVisible = props.menuItems.some(
        (item) => item.gamenId === GMN.SURVEY_YEAR_COMPANY_INFO.gmnId &&
              item.operationPermissionType ===
                  OPERATION_PERMISSION_TYPE.EXECUTE);    // 実行権限
    this.state = {
      transitionList: list,
      // 調査点検入力票情報
      inputformInfo: {
        orderNo: storage?.orderNo,
        nwOfficeCode: storage?.nwOfficeCode,
        surveyCompanyCode: storage?.surveyCompanyCode,
      },
      warningMessages: [],
      buttonDisabled: true,
      modalOpen: false,
      isDisabled: true,
      btnApplyDisabled: true,
      // 承認機能部表示判定条件
      showStepApproval: false,
      showBtnApply: false,
      showBtnApproval: false,
      showApprovalModal: false,
      showApprovalCommentModal: false,
    };
    // 一覧Ref作成
    this.gridRef = React.createRef();
    this.gmnItemsOrderList = createFieldItems(gmnItemsOrder);
    this.gmnItemsStepApprovalList = createFieldItems(gmnItemsStepApproval);
    this.setComboItems();
    this.okSelected = false;
  }

  /**
   * コンボボックス項目設定
   */
  setComboItems = () => {
    const {genericMap, userInfo} = this.props;

    // NW事業所
    this.nwOfficeCodes = userInfo.authNwOfficeCodes; // ユーザの権限よりNW事業所を取得する
    let nwOfficeList = getNewNwOfficeMap(genericMap, this.nwOfficeCodes);

    // NW事業所
    setComboList(
        this.gmnItemsOrderList,
        gmnItemsOrder.NwOfficeCode.label,
        nwOfficeList, true);
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      await this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let _warningMessages = [];
    let _inputformInfo = {...this.state.inputformInfo};
    try {
      this.props.doSetInitValues(null);
      let initItems = this.initializeItems();

      if (isEmpty(_inputformInfo.orderNo)) {
        _inputformInfo.surveyCompanyCode = initItems.surveyCompanyCode;
        _inputformInfo.nwOfficeCode = initItems.nwOfficeCode;
      }

      let _body = {
        inputformData: _inputformInfo,
      };

      // リクエスト出す
      let response = await postRequest('sci1002/search-survey-year-regist', _body);
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {
              id: response.data?.message.id,
              text: response.data?.message.text,
            },
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['調査年度・委託エリア情報', '取得']},
          });
        }
        return;
      }
      // 画面項目データ設定
      this.setInitializeData(response.data, _inputformInfo, initItems);

      if (initItems[gmnItemsOrder.ApprovalStatus.binding] ==
        SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING) {
        _warningMessages = this.inputCheck(
            initItems, response.data?.registList);
      }
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        inputformInfo: _inputformInfo,
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * セル編集終了時の調査年度委託エリア登録一覧
   * @param {object} grid グリッド
   * @param {object} event イベント
   */
  onCellEditEndedFunction = (grid, event) => {
    if (event != null) {
      const listItems = this.gridRef.current.getItems();
      if (!listItems || listItems.length === 0) {
        this.setState({btnApplyDisabled: true});
      }
    }
  };

  /**
   * 画面項目初期化
   * @return {object} 画面項目
   */
  initializeItems = () => {
    const {userInfo} = this.props;

    const gmnItems = {
      ...gmnItemsOrder,
      ...gmnItemsStepApproval,
    };

    let initItems = {};
    for (const key of Object.keys(gmnItems)) {
      const item = gmnItems[key];
      if (Object.hasOwn(item, 'binding')) {
        initItems[item.binding] = null;
      }
    }

    // Ⅰ期対応
    initItems[gmnItemsOrder.SurveyCompanyCode.binding] = CORP_CD.CBID_USER;
    initItems[gmnItemsOrder.NwOfficeCode.binding] =
        userInfo.nwOfficeCode;
    initItems[gmnItemsOrder.IssuerUserName.binding] = userInfo.userName;
    let sysDate = formatDate(new Date(), 'yyyy-MM-dd');
    initItems[gmnItemsOrder.CreateDate.binding] = sysDate;
    initItems[gmnItemsOrder.ApprovalStatus.binding] =
    SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING;

    return initItems;
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getViewElem = (view, readOnly) => {
    const _cssClass = readOnly ? '' : 'wj-cell-editable';
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      cssClass={_cssClass}
      width={view.width}
      visible={view.visible}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getViewElemComboBox = (view, readOnly) => {
    const {genericMap, userInfo} = this.props;
    const _cssClass = readOnly ? '' : 'wj-cell-editable';
    let dataList=[];
    if (view.binding === 'oldNwOfficeCode') {
      this.nwOfficeCodes = userInfo.authNwOfficeCodes;
      dataList= getNewNwOfficeMap(genericMap, this.nwOfficeCodes);
    } else {
      dataList= searchMap(
          genericMap, CATEGORY_TYPE.SURVEY_CHECK_CONSIGN_AREA_CODE);
    }
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(dataList, 'cd', 'cdNameAbbr')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: dataList,
        selectedValuePath: 'cd',
        displayMemberPath: 'cdNameAbbr',
      })}
      cssClass={_cssClass}
      isReadOnly={readOnly}/>;
  };

  /**
   * 変更前一覧描画
   * @return {*}
   */
  renderTable() {
    let isReadOnly = this.state.isDisabled;
    const props = {
      rowHeaderType: 'check',
      id: 'SCI1002Table',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'Columns',
      style: {maxHeight: 'auto', width: 'auto'},
      isReadOnly: isReadOnly,
      screenId: 'SCI1002',
      checkedFunction: this.checkStateUpdate,
      cellEditEndedFunction: this.onCellEditEndedFunction,
      doShowMessage: this.props.doShowMessage,
      validateEdits: false,
      DeleteOn: true,
      isDisplayCount: true,
      getError: this.getError,
    };
    // 一覧定義取得
    let viewElems = [];
    if (gridItems) {
      for (const view of gridItems) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, elem.readOnly));
            } else {
              viewGroups.push(this.getViewElem(elem, elem.readOnly));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, view.readOnly);
        } else {
          viewElem = this.getViewElem(view, view.readOnly);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref = {this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 調査年度・委託エリア登録一覧画面の入力チェック
   * @param {object} item 検証行データ
   * @param {string} prop binding
   * @param {boolean} parsing 予期されたデータ型に解析できない値を入力したかどうか
   * @return {string} 結果
   */
  getError = (item, prop, parsing) => {
    const {values} = this.props;
    if (parsing) {
      return null;
    }
    const targets = gridItems
        .filter((targetItem) => targetItem.binding == prop);
    let target = {};
    let groupHeader='';
    if ( targets.length > 0) {
      target= targets[0];
    } else {
      const headerGroups = gridItems.filter((targetItem) => targetItem.dataType == 'header');
      for (const group of headerGroups) {
        const targetItem = group.elems.filter(
            (targetItem) => targetItem.binding == prop);
        if (targetItem.length>0) {
          target=targetItem[0];
          groupHeader=group.header;
        }
      }
    }
    let label = createMessageLabel(null, groupHeader+target.header);
    let result = this._requiredCheck(target.required, label, item[prop]);
    if (result.error) {
      return this.props.getMessage(result.message.id, result.message.values);
    }

    result = this._lengthCheck(target.maxLength, label, item[prop]);
    if (result.error) {
      return this.props.getMessage(result.message.id, result.message.values);
    }

    // 調査年度妥当性チェック
    if (prop === 'nextSurveyFiscalYearAfter') {
      result = yearIntegerCheck(label, item[prop]);
      if (result.error) {
        return this.props.getMessage(result.message.id, result.message.values);
      }
      // 次回調査年度・下限チェック
      // 入力した次回調査年度は当該年度＋１からであること。
      if (!isEmpty(item['nextSurveyFiscalYearAfter']) &&
    parseInt(item['nextSurveyFiscalYearAfter']) < parseInt(values['basisYear']) + 1) {
        return this.props.getMessage('TKSCA00030E', ['当該年度の翌年度以降', '']);
      }

      // 次回調査年度・上限チェック
      // 区画番号ＤＢ・前回調査年度＝SPACEの場合、入力した次回調査年度は、当該年度＋４年以内であること。
      if (isEmpty(item['lastSurveyFiscalYear']) &&
                    parseInt(item['nextSurveyFiscalYearAfter']) >parseInt(values['basisYear']) + 4) {
        return this.props.getMessage('TKSCA00030E', ['当該年度＋４年以内', '']);
      }
      // 次回調査年度・上限チェック
      // 区画番号ＤＢ・前回調査年度≠SPACEの場合、入力した次回調査年度は、区画番号ＤＢ・前回調査年度＋４年以内であること。
      if (!isEmpty(item['lastSurveyFiscalYear']) &&
                    parseInt(item['nextSurveyFiscalYearAfter']) >parseInt(item['lastSurveyFiscalYear']) + 4) {
        return this.props.getMessage('TKSCA00030E', ['前回調査年度＋４年以内', '']);
      }
    }
  };

  /**
   * 一覧に変更があるかチェックする
   * @return {bool} true: 変更あり
   */
  doCheckModified = () => {
    let result = false;
    if (this.gridRef.current) {
      result = this.gridRef.current.commitAndCheck();
    }
    return result;
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doSetInitValues(null);
  }
  /**
   * ボタンの活性、非活性化
   */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef?.current &&
            this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 行削除ボタン押下時
   */
  doDelete = () => {
    let _warningMessages = null;
    try {
      if (!this.gridRef || !this.gridRef.current) {
        return;
      }
      // 未選択チェック
      const count = this.gridRef.current.selectedItemCount();
      if (count === 0) {
        this.props.doShowMessage({
          message: {
            id: 'TKSCS00028E',
            values: ['削除'],
          },
        });
        return;
      }
      const items = this.gridRef.current.selectedItem();
      let cv = this.gridRef.current.grid.collectionView;
      cv.beginUpdate();
      // 削除
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        let removeIndex = items[rowIndex].index;
        cv.removeAt(removeIndex);
      }
      cv.endUpdate();

      const listItems = this.gridRef.current.getItems();
      if (!listItems || listItems.length === 0) {
        this.setState({btnApplyDisabled: true});
      }
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 一時保存ボタン押下時
   */
  doInterimSave = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    let _inputformInfo = {...this.state.inputformInfo};

    try {
      const changeItems = this.gridRef.current.getAllItemsWithState();
      let _registList = [];

      for (const changeItem of changeItems) {
        let _item = {...changeItem};
        if (!_item.hasOwnProperty(['blockTransferDetailId'])) {
          _item['gridStatus'] = 'insert';
        }
        _item.transferDetailUpdateTime = formatStringDate(
            _item.transferDetailUpdateTime, ISO_LOCAL_DATE_TIME);
        _item.blockUpdateTime = formatStringDate(
            _item.blockUpdateTime, ISO_LOCAL_DATE_TIME);
        _item.orderVersion = formatStringDate(
            _item.orderVersion, ISO_LOCAL_DATE_TIME);
        _registList.push(_item);
      }

      _warningMessages = this.inputCheck(values, _registList);
      const cantSave = filterErrorMessage(['TKSCS00029E', 'TKSCS00009E'], _warningMessages);
      if (cantSave.length > 0) {
        this.props.doShowMessage({
          message: {id: 'TKSCS00013E'},
        });
        return;
      }

      let _body = {
        inputformData: {...values},
        registList: _registList,
        okSelected: this.okSelected,
      };

      let response = await postRequest('sci1002/save-survey-year-regist', _body);
      if (response.data?.detailMessages != null) {
        _warningMessages = response.data?.detailMessages;
      }
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          if (response.data?.message.id === 'TKSCS00053C') {
            this.props.doShowMessage({
              message: {id: response.data?.message.id,
                text: response.data?.message.text},
              action: async () => {
                this.okSelected = true;
                this.doInterimSave();
              },
            });
          } else {
            this.props.doShowMessage({
              message: {id: response.data?.message.id,
                text: response.data?.message.text},
            });
          }
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['調査年度・委託エリア情報', '保存']},
          });
        }
        return;
      }

      this.okSelected = false;
      let initItems = this.initializeItems();
      // 画面項目データ設定
      this.setInitializeData(response.data, _inputformInfo, initItems);
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
        inputformInfo: _inputformInfo,
      });
    }
  };

  /**
   * 画面項目データ設定
   * @param {Object} responseData
   * @param {Object} inputformInfo
   * @param {Object} initItems
   */
  setInitializeData = (responseData, inputformInfo, initItems) => {
    const {genericMap} = this.props;

    let registList = responseData?.registList || [];
    let inputformData = responseData?.inputformData || {};
    let approvalResponse = responseData?.approvalResponse || {};

    // 取得した調査点検入力票情報を画面項目の初期値に設定
    for (const key of Object.keys(initItems)) {
      if (Object.hasOwn(inputformData, key) && inputformData[key] != null) {
        initItems[key] = inputformData[key];
      }
    }

    // NW事業所を設定
    if (initItems[gmnItemsOrder.ApprovalStatus.binding] !==
      SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING) {
      let nwOfficeList = [{
        cd: initItems.nwOfficeCode,
        cdNameAbbr: getComboName(genericMap,
            CATEGORY_TYPE.NW_OFFICE_CODE,
            initItems.nwOfficeCode),
      }];
      setComboList(
          this.gmnItemsOrderList,
          gmnItemsOrder.NwOfficeCode.label,
          nwOfficeList, true);
    } else {
      if (!isEmpty(initItems.nwOfficeCode) &&
            initItems.nwOfficeCode !== NW_OFFICE_CODE.CHUDEN_NW &&
            !this.nwOfficeCodes.includes(initItems.nwOfficeCode)) {
        this.props.doShowMessage({
          message: {id: 'TKSCS00049E'},
        });
      }
    }

    // 承認ステータスを設定
    initItems[gmnItemsOrder.ApprovalStatusName.binding] =
        getComboName(genericMap,
            CATEGORY_TYPE.SURVEY_YEAR_CONSIGN_AREA_STATUS,
            initItems.approvalStatus);

    // 承認状況データを設定
    this.setApprovalData(approvalResponse, initItems);

    // 調査年度・委託エリア情報データを画面に設定
    this.props.doSetInitValues(initItems);

    if (this.gridRef?.current) {
      // 変更前リストデータを画面に設定
      this.gridRef.current.setItemsSource(registList);
    }

    // 調査点検入力票情報設定
    inputformInfo.orderNo = inputformData.orderNo;
    inputformInfo.basisYear = inputformData.basisYear;

    // 画面項目プロパティ設定
    this.setItemProps(initItems);

    this.setState({
      btnApplyDisabled: !(registList && registList.length > 0),
    });
  };

  /**
   * 承認状況データ設定
   * @param {Object} approvalResponse
   * @param {Object} initItems
   */
  setApprovalData = (approvalResponse, initItems) => {
    if (isEmpty(approvalResponse)) {
      initItems[gmnItemsStepApproval.StepApprovalStatus.binding] =
            STEP_APPROVAL_STATUS.SHINSEI_MI;
      return;
    }
    // 承認権限
    initItems[gmnItemsStepApproval.Approvable.binding] =
        approvalResponse.approvable;
    // 承認申請状況
    initItems[gmnItemsStepApproval.StepApprovalStatus.binding] =
        approvalResponse.approvalStatus;

    switch (approvalResponse.approvalStatus) {
      case STEP_APPROVAL_STATUS.SHINSEI_MI:
        // 承認申請がまだ、もしくは終わった場合
        // 画面の入力項目は承認申請前の状態で対応する必要がある。
        break;

      case STEP_APPROVAL_STATUS.SHINSEI_TYU:
        // 承認申請が進行中で、上司の承認待ち。
        // 承認WF ID、 承認ルートID、 承認ステップID
        initItems[gmnItemsStepApproval.WfId.binding] = approvalResponse.wfId;
        initItems[gmnItemsStepApproval.ApprovalRouteId.binding] =
            approvalResponse.approvalRouteId;
        initItems[gmnItemsStepApproval.ApprovalStepId.binding] =
            approvalResponse.approvalStepId;
        break;

      case STEP_APPROVAL_STATUS.SHINSEI_SAI:
        // 承認申請が差し戻された or 取下げたため、再度申請。
        initItems[gmnItemsStepApproval.StepApprovalComment.binding] =
            approvalResponse.comment;
        if (!isEmpty(approvalResponse.commentedTime)) {
          initItems[gmnItemsStepApproval.StepApprovalDateTime.binding] =
              formatDate(new Date(approvalResponse.commentedTime));
        }
        break;
      default:
        break;
    }
  };

  /**
   * 画面項目プロパティ設定
   * @param {Object} initItems
   */
  setItemProps = (initItems) => {
    let _isDisabled = true;
    let _showStepApproval = false;
    let _showBtnApply = false;
    let _showBtnApproval = false;

    if (isEmpty(initItems[gmnItemsOrder.ApprovalStatus.binding]) ||
          initItems[gmnItemsOrder.ApprovalStatus.binding] ===
          SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING) {
      _isDisabled = false;
    }

    // 承認申請ボタン表示
    if (initItems[gmnItemsOrder.ApprovalStatus.binding] ===
      SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING &&
        (initItems[gmnItemsStepApproval.StepApprovalStatus.binding] ===
            STEP_APPROVAL_STATUS.SHINSEI_MI ||
          initItems[gmnItemsStepApproval.StepApprovalStatus.binding] ===
              STEP_APPROVAL_STATUS.SHINSEI_SAI)) {
      _showBtnApply = true;
    }

    // 承認・否決ボタン表示
    if (initItems[gmnItemsStepApproval.Approvable.binding] &&
          ((initItems[gmnItemsOrder.ApprovalStatus.binding] ===
            SURVEY_YEAR_CONSIGNAREA_STATUS.APPROVING &&
            initItems[gmnItemsStepApproval.StepApprovalStatus.binding] ===
                STEP_APPROVAL_STATUS.SHINSEI_TYU))) {
      _showBtnApproval = true;
    }

    // 否決（枠）表示
    if ((initItems[gmnItemsOrder.ApprovalStatus.binding] ===
      SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING &&
            initItems[gmnItemsStepApproval.StepApprovalStatus.binding] ===
                STEP_APPROVAL_STATUS.SHINSEI_SAI)) {
      _showStepApproval = true;
    }

    this.gmnItemsOrderList.forEach((item) => {
      item.readOnly = _isDisabled;
      switch (item.name) {
        case gmnItemsOrder.CreateDate.binding:
          item.InputProps.readOnly = _isDisabled;
          break;
        case gmnItemsOrder.NwOfficeCode.binding:
          item.InputProps.readOnly = _isDisabled;
          break;
        default:
          break;
      }
    });

    this.setState({
      isDisabled: _isDisabled,
      showBtnApply: _showBtnApply,
      showBtnApproval: _showBtnApproval,
      showStepApproval: _showStepApproval,
    });
  };

  /**
   * 入力チェック
   * @param {object} inputData 画面入力値
   * @param {array} listData 一覧リスト
   * @return {array} エラーメッセージ
   */
  inputCheck = (inputData, listData) => {
    const {genericMap} = this.props;
    let _warning = [];
    let resultList = [];
    let rowIndex = null;

    if (!inputData && !listData) {
      return _warning;
    }

    // NW事業所
    resultList.push(requiredCheck(
        gmnItemsOrder.NwOfficeCode.label,
        inputData[gmnItemsOrder.NwOfficeCode.binding]));
    // 仕掛かり中の統合前事業所のチェック
    if (!isEmpty(inputData[gmnItemsOrder.NwOfficeCode.binding]) &&
          inputData[gmnItemsOrder.NwOfficeCode.binding] !==
            NW_OFFICE_CODE.CHUDEN_NW &&
          !this.nwOfficeCodes.includes(
              inputData[gmnItemsOrder.NwOfficeCode.binding])) {
      resultList.push(errorResult('TKSCS00049E'));
    }
    // 作成日
    resultList.push(requiredCheck(
        gmnItemsOrder.CreateDate.label,
        inputData[gmnItemsOrder.CreateDate.binding]));
    resultList.push(dateCheck(
        gmnItemsOrder.CreateDate.label,
        inputData[gmnItemsOrder.CreateDate.binding]));
    // 作成日未来日チェック
    if (!isEmpty(inputData[gmnItemsOrder.CreateDate.binding])) {
      const sysDate = formatDate(new Date());
      const createDate = formatDate(
          new Date(inputData[gmnItemsOrder.CreateDate.binding]));
      if (createDate > sysDate) {
        resultList.push(errorResult('TKSCS00045E', [gmnItemsOrder.CreateDate.label, '']));
      }
    }

    if (listData && listData.length > 0) {
      rowIndex = 0;
      let oldNwOfficeCodes = getOldNwOfficeMap(genericMap,
          inputData[gmnItemsOrder.NwOfficeCode.binding]);
      for (const data of listData) {
        if (data.gridStatus === 'delete') {
          continue;
        }

        rowIndex++;
        if (data.rowIndex == null) {
          data.rowIndex = rowIndex;
        }

        for (const gridItem of gridItems) {
          const _binding = gridItem.binding;
          if (!_binding || !Object.hasOwn(data, _binding)) {
            const _elems=gridItem.elems;
            if (!_elems) {
              continue;
            } else {
              for (const elem of _elems) {
                const _binding = elem.binding;
                const _value = data[_binding];
                const _header = gridItem.header + elem.header;
                resultList.push(this._requiredCheck(
                    elem.required, _header, _value, data.rowIndex));

                resultList.push(this._lengthCheck(
                    elem.maxLength, _header, _value, data.rowIndex));
              }
            }
          }
          const _value = data[_binding];
          const _header = gridItem.header;
          resultList.push(this._requiredCheck(
              gridItem.required, _header, _value, data.rowIndex));

          resultList.push(this._lengthCheck(
              gridItem.maxLength, _header, _value, data.rowIndex));
        }

        // 旧NW事業所所属チェック
        let isInNwOffices = oldNwOfficeCodes.map((item) => item.cd).includes(data['oldNwOfficeCode']);
        if (!isEmpty(inputData[gmnItemsOrder.NwOfficeCode.binding]) &&
              !isInNwOffices) {
          resultList.push(errorResult('TKSCS00042E',
              ['旧NW事業所', formatRowIndex(data.rowIndex)]));
        }

        // 次回調査年度妥当性チェック
        resultList.push(yearIntegerCheck('次回調査年度', data['nextSurveyFiscalYearAfter'], data.rowIndex));
        // 次回調査年度が数字以外の場合、調査管理区分、調査業種、調査年度チェックをしない
        if (isNaN(data['nextSurveyFiscalYearAfter'])) {
          continue;
        }

        // 次回調査年度・下限チェック
        // 入力した次回調査年度は当該年度＋１からであること。
        if (!isEmpty(data['nextSurveyFiscalYearAfter']) &&
                        parseInt(data['nextSurveyFiscalYearAfter']) <parseInt(inputData['basisYear']) + 1) {
          resultList.push(errorResult('TKSCA00030E',
              ['当該年度の翌年度以降', formatRowIndex(data.rowIndex)]));
        }

        // 次回調査年度・上限チェック
        // 区画番号ＤＢ・前回調査年度＝SPACEの場合、入力した次回調査年度は、当該年度＋４年以内であること。
        if (isEmpty(data['lastSurveyFiscalYear']) &&
                        parseInt(data['nextSurveyFiscalYearAfter']) >parseInt(inputData['basisYear']) + 4) {
          resultList.push(errorResult('TKSCA00031E',
              ['当該年度＋４年', formatRowIndex(data.rowIndex)]));
        }
        // 次回調査年度・上限チェック
        // 区画番号ＤＢ・前回調査年度≠SPACEの場合、入力した次回調査年度は、区画番号ＤＢ・前回調査年度＋４年以内であること。
        if (!isEmpty(data['lastSurveyFiscalYear']) &&
                        parseInt(data['nextSurveyFiscalYearAfter']) >parseInt(data['lastSurveyFiscalYear']) + 4) {
          resultList.push(errorResult('TKSCA00031E',
              ['前回調査年度＋４年', formatRowIndex(data.rowIndex)]));
        }
      }

      for (const result of resultList) {
        if (result.error) {
          _warning.push(result.message);
        }
      }
      return _warning;
    };
  };

  /**
   * 必須チェック
   * @param {*} required
   * @param {*} _header
   * @param {*} _value
   * @param {*} rowIndex
   * @return {*} 結果
   */
  _requiredCheck = (required, _header, _value, rowIndex=' ') => {
    if (required) {
      return requiredCheck(_header, _value, rowIndex);
    }
    return {};
  };

  /**
   * 桁数チェック
   * @param {*} maxLength
   * @param {*} header
   * @param {*} value
   * @param {*} rowIndex
   * @return {*} 結果
   */
  _lengthCheck = (maxLength, header, value, rowIndex=' ') => {
    if (maxLength && maxLength > 0) {
      return lengthCheck(header, value, maxLength, rowIndex);
    }
    return {};
  };

  /**
   * 取消ボタン押下時
   */
  doFullDelete = () => {
    const {values} = this.props;

    try {
      if (values.approvalStatus !== SURVEY_YEAR_CONSIGNAREA_STATUS.CREATING) {
        this.props.doShowMessage({
          message: {
            id: 'TKSCS00011E',
            values: ['ステータスが作成中以外の', '取消'],
          },
        });
        return;
      }

      this.props.doShowMessage({
        message: {id: 'TKSCS00002C', values: ['取消']},
        action: () => {
          this.doCancelAction();
        },
      });
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 取消処理
   */
  doCancelAction = async () => {
    const {values} = this.props;
    try {
      const deleteItems = this.gridRef.current.getAllItemsWithState();
      let _body = {
        inputformData: {...values},
        registList: deleteItems,
      };

      let response = await postRequest('sci1002/cancel-survey-year-regist', _body);
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['調査年度・委託エリア情報', '取消']},
          });
        }
        return;
      }

      this.props.navigate(GMN_PATH.SURVEY_YEAR_COMPANY_LIST);
    } catch (error) {
      sysErr(this.props);
    }
  };


  /**
   * 承認申請ボタン押下時
   */
  doApply = () => {
    try {
      this.props.doShowMessage({
        message: {id: 'TKSCS00002C', values: ['承認申請']},
        action: () => {
          this.doApplyAction();
        },
      });

      return;
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 承認申請処理
   */
  doApplyAction = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    let _inputformInfo = {...this.state.inputformInfo};

    try {
      const changeItems = this.gridRef.current.getAllItemsWithState();
      let _registList = [];
      for (const changeItem of changeItems) {
        let _item = {...changeItem};
        if (!_item.hasOwnProperty(['blockTransferDetailId'])) {
          _item['gridStatus'] = 'insert';
        }
        _item.transferDetailUpdateTime = formatStringDate(
            _item.transferDetailUpdateTime, ISO_LOCAL_DATE_TIME);
        _item.customerUpdateTime = formatStringDate(
            _item.customerUpdateTime, ISO_LOCAL_DATE_TIME);
        _item.orderVersion = formatStringDate(
            _item.orderVersion, ISO_LOCAL_DATE_TIME);
        _registList.push(_item);
      }

      _warningMessages = this.inputCheck(values, _registList);
      if (_warningMessages.length > 0) {
        this.props.doShowMessage({
          message: {id: 'TKSCS00012E', values: ['入力エラーがあるの', '承認申請']},
        });
        return;
      }

      let _body = {
        inputformData: {...values},
        registList: _registList,
        okSelected: this.okSelected,
      };

      let response = await postRequest('sci1002/apply-survey-year-regist', _body);
      if (response.data?.detailMessages != null) {
        _warningMessages = response.data?.detailMessages;
      }
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          if (response.data?.message.id === 'TKSCS00053C') {
            this.props.doShowMessage({
              message: {id: response.data?.message.id,
                text: response.data?.message.text},
              action: async () => {
                this.okSelected = true;
                this.doApplyAction();
              },
            });
          } else {
            this.props.doShowMessage({
              message: {id: response.data?.message.id,
                text: response.data?.message.text},
            });
          }
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['調査年度・委託エリア情報', '承認申請']},
          });
        }
        return;
      }
      this.okSelected = false;

      let initItems = this.initializeItems();
      // 画面項目データ設定
      this.setInitializeData(response.data, _inputformInfo, initItems);

      this.props.doShowMessage({
        message: {
          id: 'TKSCS00004I',
          values: ['承認申請'],
        },
      });
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
        inputformInfo: _inputformInfo,
      });
    }
  };
  /**
   * 承認ボタン押下時
   */
  doApproval = () => {
    const {values} = this.props;
    let _warningMessages = [];
    try {
      const changeItems = this.gridRef.current.getAllItemsWithState();
      _warningMessages = this.inputCheck(values, changeItems);
      if (_warningMessages.length > 0) {
        this.props.doShowMessage({
          message: {id: 'TKSCS00012E', values: ['申請エラーがあるの', '承認']},
        });
        return;
      }

      // 承認申請と承認時は年度跨ぎのチェック
      if (values.orderFiscalYear !== values.basisYear) {
        this.props.doShowMessage({
          message: {id: 'TKSCS00052E'},
        });
        return;
      }

      _warningMessages = this.versionCheck(changeItems);
      if (_warningMessages.length > 0) {
        this.props.doShowMessage({
          message: {id: 'TKSCS00051E'},
        });
        return;
      }

      this.displayApprovalComment(false, '1');
      return;
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * バージョンチェック
   * @param {array} listData 一覧リスト
   * @return {array} エラーメッセージ
   */
  versionCheck = (listData) => {
    let _warning = [];
    let resultList = [];

    if (listData && listData.length > 0) {
      for (const data of listData) {
        // 申請バージョンチェック
        if (data['orderVersion'] !== data['blockUpdateTime']) {
          resultList.push(errorResult('TKSCS00050E', [formatRowIndex(data.rowIndex)]));
        }
      }
    }

    for (const result of resultList) {
      if (result.error) {
        _warning.push(result.message);
      }
    }
    return _warning;
  };

  /**
   * 承認・否決ボタン押下時
   */
  handleApprovalExec = async () => {
    // 承認
    if (this.state.approvalType === '1') {
      this.doApprovalAction();
    } else {
      this.doRemandAction();
    }
  };

  /**
   * 承認処理
   */
  doApprovalAction = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    let _inputformInfo = {...this.state.inputformInfo};

    try {
      // 承認コメントチェック
      if (!isEmpty(values.comment) && values.comment.length > 255) {
        this.props.doShowMessage({
          message: {
            id: 'TKSCS00009E',
            values: ['コメント', ''],
          },
        });
        return;
      }

      const changeItems = this.gridRef.current.getAllItemsWithState();
      let _registList = [];
      for (const changeItem of changeItems) {
        let _item = {...changeItem};

        _item.orderVersion = formatStringDate(
            _item.orderVersion, ISO_LOCAL_DATE_TIME);
        _registList.push(_item);
      }

      let _body = {
        inputformData: {...values},
        registList: _registList,
      };

      let response = await postRequest('sci1002/approval-survey-year-regist', _body);
      if (response.data?.detailMessages != null) {
        _warningMessages = response.data?.detailMessages;
      }
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['調査年度・委託エリア情報', '承認']},
          });
        }
        return;
      }

      let initItems = this.initializeItems();
      // 画面項目データ設定
      this.setInitializeData(response.data, _inputformInfo, initItems);

      this.props.doShowMessage({
        message: {
          id: 'TKSCS00004I',
          values: ['承認'],
        },
      });
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
        inputformInfo: _inputformInfo,
      });

      // 承認・否決画面を閉じる
      this.closeApprovalComment();
    }
  };

  /**
   * 否決処理
   */
  doRemandAction = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    let _inputformInfo = {...this.state.inputformInfo};

    try {
      if (isEmpty(values.comment)) {
        this.props.doShowMessage({
          message: {
            id: 'TKSCS00005E',
            values: ['コメント', ''],
          },
        });
        return;
      } else if (values.comment.length > 255) {
        this.props.doShowMessage({
          message: {
            id: 'TKSCS00009E',
            values: ['コメント', ''],
          },
        });
      }

      let _body = {
        inputformData: {...values},
      };

      let response = await postRequest('sci1002/remand-survey-year-regist', _body);
      if (response.data?.detailMessages != null) {
        _warningMessages = response.data?.detailMessages;
      }
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['調査年度・委託エリア情報', '否決']},
          });
        }
        return;
      }

      let initItems = this.initializeItems();
      // 画面項目データ設定
      this.setInitializeData(response.data, _inputformInfo, initItems);

      this.props.doShowMessage({
        message: {
          id: 'TKSCS00004I',
          values: ['否決'],
        },
      });
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
        inputformInfo: _inputformInfo,
      });

      // 承認・否決画面を閉じる
      this.closeApprovalComment();
    }
  };

  /**
   * 行追加ボタン押下時
   */
  doAdd = () => {
    this.setState({modalOpen: true});
  };

  doClose = () => {
    this.setState({modalOpen: false});
  };

  /**
   * 承認画面の表示
   * @param {object} tstkFlag 調査・点検フラグ
   * @param {object} approvalType 承認・否決区分
   */
  displayApprovalComment = (tstkFlag, approvalType) => {
    this.setState({
      showApprovalCommentModal: true,
      tstkFlag: tstkFlag,
      approvalType: approvalType,
    });
  };

  /**
   * 承認・否決画面を閉じる
   */
  closeApprovalComment = () => {
    this.props.change('comment', '');
    this.setState({
      showApprovalCommentModal: false,
    });
  };


  /**
   * 共通表示内容の取得
   * @param {*} items
   */
  getSelectItems = (items) => {
    this.addRow(items);
    this.setState({modalOpen: false});
  };

  /**
   * 行新規
   * @param {*} newRows 新行
   */
  addRow = (newRows) => {
    let cv = this.gridRef.current.grid.collectionView;
    let _itemsCount = cv.sourceCollection.length;
    let _topIndex = cv.sourceCollection.length;
    if (newRows) {
      _itemsCount = _itemsCount + newRows.length;
    }
    if ((_itemsCount) > 100) {
      this.props.doShowMessage({
        message: {id: 'TKSCS00040E', values: [100]},
      });
      return;
    }

    let oldRows = this.gridRef.current.getItems();
    cv.beginUpdate();
    if (newRows) {
      for (const newRow of newRows) {
        let newRowData = newRow._data;
        // 選択されたお客さまはすでに明細に存在している場合、再追加不要。（追加をスキップする）
        let checkRes = oldRows.filter((oldRow) =>
          oldRow.oldNwOfficeCode === newRowData.oldNwOfficeCode &&
          oldRow.blockNo === newRowData.blockNo);
        // エラーとする
        if (checkRes && checkRes.length > 0) {
          continue;
        }

        let _newItem = cv.addNew();
        if (_newItem) {
          let _newRow = {
            oldNwOfficeCode: newRowData.oldNwOfficeCode,
            blockNo: newRowData.blockNo,
            lastSurveyFiscalYear: newRowData.lastSurveyFiscalYear,
            nextSurveyFiscalYearBefore: newRowData.nextSurveyFiscalYear,
            nextSurveyFiscalYearAfter: newRowData.nextSurveyFiscalYear,
            lastSurveyCheckConsignAreaCode:
            newRowData.lastSurveyCheckConsignAreaCode,
            nextSurveyCheckConsignAreaCodeBefore:
             newRowData.nextSurveyCheckConsignAreaCode,
            nextSurveyCheckConsignAreaCodeAfter:
             newRowData.nextSurveyCheckConsignAreaCode,
            orderVersion: newRowData.updateTime, //  区画番号の更新日時
          };

          _newItem = Object.assign(_newItem, _newRow);

          _topIndex = _topIndex + 1;
          _newItem['rowId'] = _topIndex;
          _newItem['rowIndex'] = _topIndex;
          cv.commitNew();
        }
      }
    }
    cv.endUpdate();
    this.gridRef.current.grid.refresh();

    if (_itemsCount > 0) {
      this.setState({btnApplyDisabled: false});
    }
  };
  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const isDisabled = this.state.isDisabled;
    const isShowCancel = !isDisabled &&
        !isEmpty(this.state.inputformInfo.orderNo);

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {this.isVisible && !isDisabled &&
        <Grid key="keySCI1002InterimSave" item>
          <PositiveButton
            id="btnSCI1002InterimSave"
            onClick={this.doInterimSave}
            variant="contained"
            startIcon={<SaveAltIcon />}
            disabled={this.state.btnApplyDisabled}
          >
            <span>一時保存</span>
          </PositiveButton>
        </Grid>
        }
        {this.isVisible && isShowCancel &&
        <Grid key="keySCI1002FullDelete" item>
          <DangerButton
            id="btnSCI1002FullDelete"
            onClick={this.doFullDelete}
            variant="contained"
            startIcon={<Cancel />}
          >
            <span>取消</span>
          </DangerButton>
        </Grid>}
        {this.isVisible && this.state.showBtnApply &&
        <Grid key="keySCI1002Apply" item>
          <PositiveButton
            id="keySCI1002Apply"
            onClick={this.doApply}
            variant="contained"
            startIcon={<SaveIcon />}
            disabled={this.state.btnApplyDisabled}
          >
            <span>承認申請</span>
          </PositiveButton>
        </Grid>}
        {this.isVisible && this.state.showBtnApproval &&
        <Grid key="keySCI1002Approval" item>
          <PositiveButton
            id="btnSCI1002Approval"
            onClick={this.doApproval}
            variant="contained"
            startIcon={<CheckCircle />}
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>
        }
        {this.isVisible && this.state.showBtnApproval &&
        <Grid key="keySCI1002Remand" item>
          <DangerButton
            id="btnSCI1002Remand"
            onClick={()=>{
              this.displayApprovalComment(false, '2');
            }}
            variant="contained"
            startIcon={<Cancel />}
          >
            <span>否決</span>
          </DangerButton>
        </Grid>
        }
        <Grid key="keySCI1002ApprovalState" item>
          <PositiveButton
            id="btnSCI1002ApprovalState"
            onClick={this.displayApproval}
            variant="contained"
          >
            <span>承認状況</span>
          </PositiveButton>
        </Grid>
      </Grid>

    );
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
   * 承認状況画面画面を閉じる
   */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };

  /**
   * 画面遷移
   * @param {object} path 遷移パス
   */
  doMoveNext = async (path) => {
    if (this.props.dirty || this.doCheckModified()) {
      this.props.doShowMessage({
        message: 'TKSCS00038W',
        action: () => {
          // OKを押すと画面遷移
          this.props.navigate(path);
        },
      });
    } else {
      // 編集されていない場合は確認なしで遷移
      this.props.navigate(path);
    }
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {userInfo, values} = this.props;
    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className="form_root">
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          <Grid key="keySCI1002Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <CustomBreadcrumbs key="keySCI1002Breadcrumbs" items={this.state.transitionList} move={this.doMoveNext}/>
          <Grid key="keySCI1002OrderGrid" item xs={12}>
            <PaperPart>
              {createGridFields(GMN.SURVEY_YEAR_COMPANY_INFO.id,
                  this.gmnItemsOrderList)}
            </PaperPart>
            {this.state.showStepApproval &&
            <span>
              <PaperPart>
                <Typography variant="h6" gutterBottom>否決</Typography>
                {createGridFields(GMN.SURVEY_YEAR_COMPANY_INFO.id,
                    this.gmnItemsStepApprovalList)}
              </PaperPart>
            </span>
            }
            <div style={{marginBottom: '20px'}} />
            <Divider variant="middle" />
            <div style={{marginBottom: '20px'}} />
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="keySCI1002HenkomaeTable" item xs={12}>
                {this.renderTable()}
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
              direction={'row'}
            >
              <Grid key="keySCI1002LineAdd" item>
                <PositiveButton
                  id="btnSCI1002LineAdd"
                  onClick={this.doAdd}
                  variant="contained"
                  startIcon={<AddIcon />}
                  disabled={this.state.isDisabled}
                >
                  <span>行追加</span>
                </PositiveButton>
              </Grid>
              <Grid key="keySCI1002LineDelete" item>
                <DangerButton
                  id="btnSCI1002LineDelete"
                  onClick={this.doDelete}
                  variant="contained"
                  startIcon={<DeleteIcon />}
                  disabled={this.state.buttonDisabled || this.state.isDisabled}
                >
                  <span>行削除</span>
                </DangerButton>
              </Grid>
            </Grid>
          </Grid>
        </MainContainer>
        {this.state.modalOpen &&
        <SCI1003
          modalOpen={this.state.modalOpen}
          closeButton={this.doClose}
          selectButton={this.getSelectItems}
          selectNwOfficeCode={values.nwOfficeCode}></SCI1003>}
        {this.state.showApprovalModal &&
          <ApprovalStatus
            openState={this.state.showApprovalModal}
            handleClose = {this.closeApproval}/>
        }
        {this.state.showApprovalCommentModal &&
          <ApprovalComment
            openState={this.state.showApprovalCommentModal}
            tstkFlag={this.state.tstkFlag}
            approvalType={this.state.approvalType}
            handleExec={this.handleApprovalExec}
            handleClose ={this.closeApprovalComment}/>
        }
      </form>
    );
  }
}

const FORM_NAME = 'SCI1002FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  userInfo: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  genericMap: PropTypes.object,
  getMessage: PropTypes.func,
  dirty: PropTypes.bool,
  reset: PropTypes.func,
  change: PropTypes.func,
  menuItems: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
    menuItems: state.auth.menuItems,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withFormatMessage(withMediaQuery()(Container))));
